import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import stylesPc from "./UploadVideo.module.css";
import stylesSp from "./UploadVideo_SP.module.css";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Modal from "@material-ui/core/Modal";
import SelectTag from "./SelectTag";
import {
    Chip,
    CircularProgress,
    createStyles,
    createTheme,
    makeStyles,
    ThemeProvider,
} from "@material-ui/core";
import AddCircleOutlineOutlinedIcon from "@material-ui/icons/AddCircleOutlineOutlined";
import { GetGroupList, GetUserInfoList } from "../../user/UserActions";
import { AppState } from "../../root/RootReducer";
import {
    AddVideo,
    DeleteMediaRecorderVideoFile,
    ResetDuplicateError,
} from "../../common/video/VideoActions";
import UploadDocument from "../../pages/vod/Common/UploadDocument";
import { countCharLength } from "../../utils/ValidationUtils";
import PuiMessage from "../../components/widgets/PuiMessage";
import SelectGroup from "../../pages/admin/EditUser/SelectGroup";
import { Group } from "../../user/User";
import { ExtractFileName, GetTagIdFromTagName } from "../../utils/ObjectUtils";
import PuiFloatButton from "../../components/elements/PuiFloatButton";
import { IsDevice } from "../../components/function/useDeviceFlag";

interface UploadVideoProps {
    setIsSaved: (isSaved: boolean) => void;
    isSaved: boolean;
    closeUploadModal?: () => void;
}

const useStyles = makeStyles(() =>
    createStyles({
        input: {
            width: "100%",
            fontFamily: "noto-sans-cjk-jp !important",
            "& .MuiInputBase-root": {
                // color: "white",
                "& .MuiOutlinedInput-notchedOutline": {
                    // borderColor: "white",
                },
            },
            "& .MuiOutlinedInput-root": {
                // borderColor: "white",
                "&.Mui-focused fieldset": {
                    borderColor: "var(--main)",
                },
            },
        },
        select: {
            // color: "white",
            fontFamily: "noto-sans-cjk-jp !important",
            "& .MuiOutlinedInput-notchedOutline": {
                // borderColor: "white",
            },
            "& .MuiSelect-iconOutlined": {
                // color: "white",
            },
            "& .MuiInputLabel-root.Mui-focused": {
                borderColor: "var(--red)",
            },
        },
    })
);

// const defaultGroup: Group[] = [
//     {
//         id: "1",
//         title: "pactera",
//         description: "pactera group",
//         userList: [],
//         videoList: [],
//     },
// ];

const theme = createTheme({
    palette: {
        secondary: {
            main: "#12e07e",
        },
    },
});

export default function UploadVideo({ setIsSaved, isSaved, closeUploadModal }: UploadVideoProps) {
    const classes = useStyles();

    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    // ユーザー取得
    const { professionals, isSendVideo, isLoading, tags, mediaRecorderVideoFile } = useSelector(
        (state: AppState) => ({
            professionals: state.user.userInfoList,
            isSendVideo: state.video.isSendVideo,
            isLoading: state.user.isLoading,
            tags: state.video.tags,
            mediaRecorderVideoFile: state.video.mediaRecorderVideoFile,
        })
    );

    const dispatch = useDispatch();
    const inputVideoRef = useRef<HTMLInputElement>(null);
    const inputImageRef = useRef<HTMLInputElement>(null);

    // タグ選択モーダル画面
    const [tagList, setTagList] = React.useState<string[]>([]);

    //APIコール
    useEffect(() => {
        dispatch(GetUserInfoList());
        dispatch(GetGroupList());
    }, [dispatch]);

    const [inputVideoFile, InputVideoFile] = useState<File | null>(null);
    const [inputVideoFileName, InputVideoFileName] = useState("");
    const [inputVideoName, InputVideoName] = useState("");
    const [visiblePreviewImage, ChangevisiblePreviewImage] = useState(false);
    const [inputImageFile, InputImageFile] = useState(null);
    const [inputVideoProfessional, InputVideoProfessional] = useState("-1");
    const [inputVideoDetail, InputVideoDetail] = useState("");

    const [isErrorInputSize, ChangeErrorInputSize] = useState(false);
    // ファイルサイズエラーバー消去
    const CloseErrorInputBar = () => {
        ChangeErrorInputSize(false);
    };

    const UserInputVideoFile = (event: any) => {
        InputVideoFile(event.target.files[0]);
        InputVideoFileName(event.target.files[0].name);
        InputVideoName(ExtractFileName(event.target.files[0].name));
        setIsSaved(false);
    };

    // 動画スクリーンキャプチャで生成した動画ファイルを保存する
    const SetMediaRecorderVideoFile = (file: File) => {
        InputVideoFile(file);
        // InputVideoFileName(new Date().getTime() + ".mp4");
        InputVideoFileName(file.name);
        InputVideoName(ExtractFileName(file.name));
        ChangeTextUploadVideo(file.name);
        setIsSaved(false);
    };

    const UserInputVideoName = (event: any) => {
        InputVideoName(event.target.value);
        setIsSaved(false);
    };
    const UserInputImageFile = (event: any) => {
        InputImageFile(event.target.files[0]);
        setIsSaved(false);
    };
    const UserInputVideoProfessional = (event: any) => {
        InputVideoProfessional(event.target.value);
        setIsSaved(false);
    };
    const UserInputVideoDescription = (event: any) => {
        InputVideoDetail(event.target.value);
        setIsSaved(false);
    };

    // ビデオタイトルチェック
    const [isErrorTitleValidation, CheckTitleValidation] = useState(false);
    const ChangeTitle = (event: any) => {
        if (countCharLength(event.target.value) > 80) {
            UserInputVideoName(event);
            CheckTitleValidation(true);
        } else {
            CheckTitleValidation(false);
            UserInputVideoName(event);
        }
        setIsSaved(false);
    };

    //ビデオ要約チェック
    const [isErrorDescriptionValidation, CheckDescriptionValidation] = useState(false);
    const ChangeDescription = (event: any) => {
        if (countCharLength(event.target.value) > 400) {
            UserInputVideoDescription(event);
            CheckDescriptionValidation(true);
        } else {
            CheckDescriptionValidation(false);
            UserInputVideoDescription(event);
        }
        setIsSaved(false);
    };

    // 資料アップロード
    const [inputDocumentList, ChangeDocumentList] = useState<File[]>([]);
    const [inputDocumentNameList, ChangeDocumentNameList] = useState<string[]>([]);
    const [isErrorDocumentListLength, ErrorDocumentListLength] = useState(false);

    // ビデオファイルアップロードテキスト
    const [textUploadVideo, ChangeTextUploadVideo] =
        useState("アップロードするファイルを選択（1GBまで）");
    const [isLimitInputFileSize, ChangeLimitInputFileSize] = useState(false);
    const UserUploadVideo = (event: any) => {
        if (event.target.files.length === 0) {
            ChangeTextUploadVideo("アップロードするファイルを選択（1GBまで）");
            InputVideoFile(null);
            InputVideoFileName("");
            if (inputVideoRef.current) {
                inputVideoRef.current.value = "";
            }
        } else if (event.target.files.length === 1) {
            if (event.target.files[0].size > 0) {
                if (event.target.files[0].size > 1073741824) {
                    ChangeLimitInputFileSize(true);
                    if (inputVideoRef.current) {
                        inputVideoRef.current.value = "";
                    }
                } else {
                    UserInputVideoFile(event);
                    ChangeTextUploadVideo(event.target.files[0].name);
                }
            } else {
                ChangeErrorInputSize(true);
                if (inputVideoRef.current) {
                    inputVideoRef.current.value = "";
                }
            }
        } else {
            ChangeTextUploadVideo("ファイルを正しく選択してください（1GBまで）");
            InputVideoFile(null);
            InputVideoFileName("");
            if (inputVideoRef.current) {
                inputVideoRef.current.value = "";
            }
        }
        setIsSaved(false);
    };

    // ファイルサイズ制限バー消去
    const CloseLimitInputFileBar = () => {
        ChangeLimitInputFileSize(false);
    };

    // 画像ファイルアップロードテキスト
    const [textUploadImage, ChangeTextUploadImage] = useState("Videoサムネイル用のファイルを選択");
    const [isLimitInputImageSize, ChangeLimitInputImageSize] = useState(false);
    const UserUploadImage = (event: any) => {
        if (event.target.files.length === 0) {
            ChangevisiblePreviewImage(false);
            ChangeTextUploadImage("Videoサムネイル用のファイルを選択");
            InputImageFile(null);
            if (inputImageRef.current) {
                inputImageRef.current.value = "";
            }
        } else if (event.target.files.length === 1) {
            if (event.target.files[0].size > 0) {
                if (event.target.files[0].size > 10485760) {
                    ChangeLimitInputImageSize(true);
                    if (inputImageRef.current) {
                        inputImageRef.current.value = "";
                    }
                } else {
                    UserInputImageFile(event);
                    ChangeTextUploadImage(event.target.files[0].name);
                    InputImageFile(event.target.files[0]);
                    ChangevisiblePreviewImage(true);
                }
            } else {
                ChangeErrorInputSize(true);
                if (inputImageRef.current) {
                    inputImageRef.current.value = "";
                }
            }
        } else {
            ChangevisiblePreviewImage(false);
            ChangeTextUploadImage("ファイルを正しく選択してください");
            InputImageFile(null);
            if (inputImageRef.current) {
                inputImageRef.current.value = "";
            }
        }
        setIsSaved(false);
    };

    // サムネイルサイズ制限バー消去
    const CloseLimitInputImageBar = () => {
        ChangeLimitInputImageSize(false);
    };

    // ユーザのプレビュー画像クリックで、テキスト表示に戻す
    const ClickPreviewImage = (event: any) => {
        ChangeTextUploadImage("Videoサムネイル用のファイルを選択（1GBまで）");
        InputImageFile(null);
        ChangevisiblePreviewImage(false);
        setIsSaved(false);
    };

    // タグ選択モーダル画面表示制御
    const [isOpenTagSelectModal, ShowTagSelectModal] = useState(false);
    const OpenTagSelectModal = () => {
        ShowTagSelectModal(true);
    };
    const CloseTagSelectModal = () => {
        ShowTagSelectModal(false);
        dispatch(ResetDuplicateError());
    };

    const handleDelete = (tagName: string) => () => {
        setTagList((tagList) => tagList.filter((v) => v !== tagName));
        setIsSaved(false);
    };

    // グループ選択モーダル画面表示制御
    const [isOpenGroupSelectModal, ShowGroupSelectModal] = useState(false);
    const [group, setGroup] = useState<Group[]>([]);
    // const [defaultGroup, setDefaultGroup] = useState<UpdateGroup[]>();

    const OpenGroupSelectModal = () => {
        ShowGroupSelectModal(true);
    };
    const CloseGroupSelectModal = () => {
        ShowGroupSelectModal(false);
        // ChangeEditUserGroup([]);
    };
    const SetVideoGroup = (updateGroupList: Group[]) => {
        // const changeIndex = userData.findIndex(({id}) => id === editUserId);
        // userData[changeIndex]["group"] = updateGroupList;
        setGroup(updateGroupList);
        setIsSaved(false);
    };

    const handleDeleteGroup = (groupName: string) => () => {
        setGroup((group) => group.filter((v) => v.title !== groupName));
        setIsSaved(false);
    };

    // 入力内容をバックエンドに送信
    const UploadVideo = () => {
        if (
            inputVideoName !== "" &&
            inputVideoDetail !== "" &&
            inputVideoProfessional !== "-1" &&
            inputVideoProfessional !== "" &&
            inputVideoFile !== null &&
            isErrorTitleValidation === false &&
            isErrorDescriptionValidation === false
        ) {
            dispatch(
                AddVideo({
                    file: inputVideoFile,
                    imageFile: inputImageFile,
                    documentFile: inputDocumentList,
                    documentName: inputDocumentNameList,
                    video: {
                        title: inputVideoName,
                        description: inputVideoDetail,
                        presenter: inputVideoProfessional,
                        filename: inputVideoFileName,
                        tags: GetTagIdFromTagName(tagList, tags),
                        group: group.map((item) => Number(item.id)),
                    },
                })
            );

            // 入力内容リセット
            ResetUserInput();
        }
    };

    // 登録ボタンの有無効制御
    const [isReadyToUpdate, ChangeReadyToSendFlag] = useState(false);
    useEffect(() => {
        if (
            !isSaved &&
            inputVideoName !== "" &&
            inputVideoDetail !== "" &&
            inputVideoProfessional !== "-1" &&
            inputVideoProfessional !== "" &&
            inputVideoFile !== null &&
            !isErrorTitleValidation &&
            !isErrorDescriptionValidation &&
            !isErrorDocumentListLength
        ) {
            ChangeReadyToSendFlag(false);
        } else {
            ChangeReadyToSendFlag(true);
        }
    }, [
        isSaved,
        inputVideoName,
        inputVideoDetail,
        inputVideoProfessional,
        inputVideoFile,
        isErrorTitleValidation,
        isErrorDescriptionValidation,
        isErrorDocumentListLength,
    ]);

    useEffect(() => {
        if (!mediaRecorderVideoFile) return;
        SetMediaRecorderVideoFile(mediaRecorderVideoFile);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mediaRecorderVideoFile]);

    // 入力内容リセット
    const ResetUserInput = () => {
        ChangeTextUploadVideo("アップロードするファイルを選択（1GBまで）");
        InputVideoFile(null);
        InputVideoFileName("");
        if (inputVideoRef.current) {
            inputVideoRef.current.value = "";
        }
        InputVideoName("");
        ChangevisiblePreviewImage(false);
        InputImageFile(null);
        ChangeTextUploadImage("Videoサムネイル用のファイルを選択");
        if (inputImageRef.current) {
            inputImageRef.current.value = "";
        }
        InputVideoProfessional("-1");
        InputVideoDetail("");
        ChangeDocumentList([]);
        ChangeDocumentNameList([]);
        setTagList([]);
        setGroup([]);
        // setGroup(defaultGroup);
        setIsSaved(true);
        dispatch(DeleteMediaRecorderVideoFile());
    };

    // 表示待機
    if (isLoading) {
        return (
            <div className={styles.noContent}>
                <CircularProgress size={60} style={{ color: "var(--loading-bg)" }} />
            </div>
        );
    }

    return (
        <div className={styles.root}>
            <ul className={styles.inputForm}>
                <FormControl className={styles.uploadForm}>
                    <form name="addVideoForm" id="addVideoForm">
                        {!IsDevice("desktop") && (
                            <div onClick={closeUploadModal} className={styles.closeButton}>
                                <img
                                    src={require("../../assets/image/closeFilter.svg")}
                                    alt="close"
                                />
                            </div>
                        )}
                        {/* ビデオファイル */}
                        <li>
                            <div className={styles.formHelperText}>
                                Videoファイル
                                <span style={{ color: "var(--red)", fontSize: 15 }}>＊</span>
                            </div>
                            <div className={styles.form}>
                                <label className={styles.uploadButton}>
                                    {/* ビデオアップロードのみ、PDF削除 */}
                                    <input
                                        id="browserVideoUploader"
                                        ref={inputVideoRef}
                                        multiple
                                        type="file"
                                        accept="video/*"
                                        onChange={UserUploadVideo}
                                        className={styles.fileDisplay}
                                    />
                                    {textUploadVideo}
                                </label>
                            </div>
                        </li>
                        {/* 動画スクリーンキャプチャ */}
                        {/* <li>
                            <div className={styles.formHelperText}>
                            </div>
                            <div className={styles.form}>
                                <CustomMediaRecorder setMediaRecorderVideoFile={SetMediaRecorderVideoFile}/>
                            </div>
                        </li> */}
                        {/*PDFファイル */}
                        {/* <li> */}
                        {/* <div className={styles.formHelperText}>PDFファイル</div>
                        <div className={styles.form}>
                        <label className={styles.uploadButton}>
                                    <input ref={inputSlideRef} id="inputSlideUploader" accept="application/pdf" multiple type="file" onChange={UserUploadSlide} className={styles.fileDisplay}/>アップロードするファイルを選択(100MBまで)
                                </label>
                        </div> */}
                        {/* </li> */}
                        {/* 画像サムネイルファイル */}
                        <li>
                            <div className={styles.formHelperText}>サムネイル</div>
                            {visiblePreviewImage ? (
                                inputImageFile !== null && (
                                    <div style={{ display: "flex" }}>
                                        <div className={styles.previewImage}>
                                            <img
                                                style={{ cursor: "pointer" }}
                                                alt="thumbnail"
                                                src={window.URL.createObjectURL(inputImageFile)}
                                                onClick={ClickPreviewImage}
                                            />
                                        </div>
                                        <p className={styles.previewText}>
                                            サムネイル画像を指定しない場合は、Videoから自動的にサムネイルが抽出されます
                                        </p>
                                    </div>
                                )
                            ) : (
                                <div className={styles.form}>
                                    <label className={styles.uploadButton}>
                                        <input
                                            id="browserPhotoUploader"
                                            ref={inputImageRef}
                                            multiple
                                            type="file"
                                            accept="image/*"
                                            onChange={UserUploadImage}
                                            className={styles.fileDisplay}
                                        />
                                        {textUploadImage}
                                    </label>
                                </div>
                            )}
                        </li>

                        {/* タイトル */}
                        <ThemeProvider theme={theme}>
                            <li>
                                <div className={styles.formHelperText}>
                                    タイトル
                                    <span style={{ color: "var(--red)", fontSize: 15 }}>＊</span>
                                </div>
                                <div className={styles.form}>
                                    <TextField
                                        color="secondary"
                                        className={classes.input}
                                        id="VideoName"
                                        variant="outlined"
                                        placeholder="Videoタイトルを入力"
                                        autoComplete="off"
                                        value={inputVideoName}
                                        onChange={ChangeTitle}
                                        error={isErrorTitleValidation}
                                        helperText={
                                            isErrorTitleValidation && (
                                                <span style={{ color: "var(--red)" }}>
                                                    全角40文字（半角80文字）以内で正しく入力してください
                                                </span>
                                            )
                                        }
                                    />
                                </div>
                            </li>

                            {/* プロフェッショナル */}
                            <li>
                                <div className={styles.formHelperText}>
                                    Presenter
                                    <span style={{ color: "var(--red)", fontSize: 15 }}>＊</span>
                                </div>
                                <div className={styles.form}>
                                    <Select
                                        color="secondary"
                                        id="selectProfessional"
                                        variant="outlined"
                                        defaultValue="-1"
                                        onChange={UserInputVideoProfessional}
                                        value={inputVideoProfessional}
                                        className={classes.select}
                                    >
                                        <MenuItem value={"-1"}>Presenterを選択</MenuItem>

                                        {professionals &&
                                            professionals.length > 0 &&
                                            professionals.map(
                                                (row) =>
                                                    row.roles.includes("PRESENTER") && (
                                                        <MenuItem key={row.id} value={row.id}>
                                                            {row.fullName}
                                                        </MenuItem>
                                                    )
                                            )}
                                    </Select>
                                </div>
                            </li>

                            {/* 要約 */}

                            <li>
                                <div className={styles.formHelperTextLong}>
                                    要約
                                    <span style={{ color: "var(--red)", fontSize: 15 }}>＊</span>
                                </div>

                                <div className={styles.form}>
                                    <TextField
                                        color="secondary"
                                        id="description"
                                        onChange={ChangeDescription}
                                        className={classes.input}
                                        multiline
                                        minRows={5}
                                        autoComplete="off"
                                        value={inputVideoDetail}
                                        variant="outlined"
                                        placeholder="Video要約を入力"
                                        error={isErrorDescriptionValidation}
                                        helperText={
                                            isErrorDescriptionValidation && (
                                                <span style={{ color: "var(--red)" }}>
                                                    全角200文字（半角400文字）以内で正しく入力してください
                                                </span>
                                            )
                                        }
                                    />
                                </div>
                            </li>
                        </ThemeProvider>

                        {/* 資料 */}
                        <li>
                            <div className={styles.formHelperTextLong}>資料</div>
                            <UploadDocument
                                alreadyUploadDocumentList={[]}
                                setIsSaved={setIsSaved}
                                ChangeDocumentList={ChangeDocumentList}
                                documentList={inputDocumentList}
                                ChangeDocumentNameList={ChangeDocumentNameList}
                                documentNameList={inputDocumentNameList}
                                ErrorDocumentListLength={ErrorDocumentListLength}
                            />
                        </li>

                        {/* タグ（モーダル表示） */}
                        <li>
                            <div className={styles.formHelperTextLong}>タグ</div>
                            <div className={styles.formTag}>
                                <AddCircleOutlineOutlinedIcon
                                    style={{ cursor: "pointer", color: "var(--main)" }}
                                    color="secondary"
                                    fontSize="large"
                                    onClick={OpenTagSelectModal}
                                />
                            </div>
                            <div className={styles.tags}>
                                {tagList &&
                                    tagList.map((tag) => (
                                        <Chip
                                            key={tag}
                                            label={tag}
                                            color="secondary"
                                            size="medium"
                                            style={{ backgroundColor: "var(--main)" }}
                                            className={styles.tag}
                                            onDelete={handleDelete(tag)}
                                        />
                                    ))}
                            </div>
                        </li>

                        {/* グループ（モーダル表示） */}
                        <li>
                            <div className={styles.formHelperTextLong}>Group</div>
                            <div className={styles.formTag}>
                                <AddCircleOutlineOutlinedIcon
                                    style={{ cursor: "pointer", color: "var(--main)" }}
                                    color="secondary"
                                    fontSize="large"
                                    onClick={OpenGroupSelectModal}
                                />
                            </div>
                            <div className={styles.tags}>
                                {group &&
                                    group.length > 0 &&
                                    group.map((group) => (
                                        <Chip
                                            key={group.id}
                                            label={group.title}
                                            color="secondary"
                                            size="medium"
                                            style={{ backgroundColor: "var(--main)" }}
                                            className={styles.tag}
                                            onDelete={handleDeleteGroup(group.title)}
                                        />
                                    ))}
                            </div>
                        </li>
                        {/* ビデオ追加ボタン */}

                        <div className={styles.updateButton}>
                            <PuiFloatButton
                                children={["　登録　"]}
                                size="medium"
                                isActive={isSendVideo ? isReadyToUpdate : !isReadyToUpdate}
                                color="secondary"
                                onClick={UploadVideo}
                            />
                        </div>
                    </form>
                </FormControl>
            </ul>

            {/* タグ選択モーダル */}
            <Modal open={isOpenTagSelectModal} onClose={CloseTagSelectModal}>
                <SelectTag
                    in={isOpenTagSelectModal}
                    onClose={CloseTagSelectModal}
                    tagList={tagList}
                    setTagList={setTagList}
                    setIsSaved={setIsSaved}
                />
            </Modal>

            {/* グループ選択モーダル */}
            <Modal open={isOpenGroupSelectModal} onClose={CloseGroupSelectModal}>
                <SelectGroup
                    visibleModal={isOpenGroupSelectModal}
                    onClose={CloseGroupSelectModal}
                    targetName={inputVideoFileName}
                    userGroup={group}
                    SetGroupList={SetVideoGroup}
                    SetIsSaved={setIsSaved}
                />
            </Modal>

            <PuiMessage
                open={isLimitInputFileSize}
                onClose={CloseLimitInputFileBar}
                type="error"
                title="1GB以上のファイルはアップロードできません"
                duration={5000}
            />

            {/* アップロードイメージサムネイルサイズチェック */}
            <PuiMessage
                open={isLimitInputImageSize}
                onClose={CloseLimitInputImageBar}
                type="error"
                title="10MB以上の画像はアップロードできません"
                duration={5000}
            />

            <PuiMessage
                open={isErrorInputSize}
                type="error"
                title="正しいファイルを選択してください"
                duration={5000}
                onClose={CloseErrorInputBar}
            />
        </div>
    );
}
